import HistoryForLicense from "./historyForLicense";

export default HistoryForLicense;
